import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Userpage from "./Userpage";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Adminlogin from "./adminlogin";
import reportWebVitals from "./reportWebVitals";
import AuthProvider from "./AuthProvider";
import Allcomplaints_admin from "./Allcomplaints_admin";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route index path="/" element={<App />} />

        <Route
          path="/adminpage"
          element={
            <AuthProvider user="admin">
              <Allcomplaints_admin />
            </AuthProvider>
          }
        />
        <Route path="/adminlogin" element={<Adminlogin />} />
        <Route
          path="/userpage"
          element={
            <AuthProvider user="user">
              <Userpage />
            </AuthProvider>
          }
        />
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
